import { Professione } from '@hm_app/@core/models/dettaglio_profilo';
import { Injectable, Type } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { TitoloStudio } from '@hm_app/@core/models/dettaglio_profilo';

@Injectable()
export class TitoloStudioService {

    // Observable sources
    private titolo_studio = new BehaviorSubject<TitoloStudio>(null);

    // Observable streams
    titolo_studioObservable = this.titolo_studio.asObservable();

    // Service message commands
    passTitoloStudio(titolo_studio: TitoloStudio) {
        this.titolo_studio.next(titolo_studio);
    }
}
